import { useQuery, type UseQueryResult } from "@tanstack/react-query"
import { AppointmentRequest } from "../types/appointmentRequest"

type FetchAppointmentRequestParams = {
  appointmentId?: string
  appointmentStatus?: string
  token?: string | null
}

export async function fetchAppointmentRequests({
  appointmentId,
  token,
}: FetchAppointmentRequestParams): Promise<AppointmentRequest[]> {
  const response = await fetch(`/api/appointment/${appointmentId}/responses`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })

  const appointmentResponses = (await response.json()) as AppointmentRequest[]
  return appointmentResponses
}

export const useAppointmentRequestQuery = ({
  appointmentId,
  appointmentStatus,
  token,
}: FetchAppointmentRequestParams): UseQueryResult<AppointmentRequest[]> =>
  useQuery({
    queryKey: ["appointment-requests", appointmentId],
    queryFn: async () => await fetchAppointmentRequests({ appointmentId, token }),
    enabled: !!token && !!appointmentId && appointmentStatus === "pending",
  })
